require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-is-multi-currency-the-secret-solution-to-going-global-with-your-e-commerce-brand.json") })
        }
      }, "path---blog-is-multi-currency-the-secret-solution-to-going-global-with-your-e-commerce-brand");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-is-multi-currency-the-secret-solution-to-going-global-with-your-e-commerce-brand!./.cache/json/blog-is-multi-currency-the-secret-solution-to-going-global-with-your-e-commerce-brand.json
// module id = 475
// module chunks = 231608221292675